import * as tslib_1 from "tslib";
import { lazyForceCloseSxS } from '../index';
import sxsStore from '../store/Store';
import { isAttachmentFeatureEnabled } from 'owa-attachment-feature-flags';
import { lazyClosePreview } from 'owa-preview-pane-store';
export default function closeAllSxS(closingSource) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var forceCloseSxS;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!isAttachmentFeatureEnabled('doc-SxS-refactor')) return [3 /*break*/, 2];
                    return [4 /*yield*/, lazyForceCloseSxS.import()];
                case 1:
                    forceCloseSxS = _a.sent();
                    forceCloseSxS(sxsStore, closingSource);
                    return [3 /*break*/, 4];
                case 2: return [4 /*yield*/, lazyClosePreview.importAndExecute(closingSource)];
                case 3:
                    _a.sent();
                    _a.label = 4;
                case 4: return [2 /*return*/];
            }
        });
    });
}
//# sourceMappingURL=closeAllSxS.js.map